<template>
  <div>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <h2 class="pull-left">{{contractingAuthority.name}}</h2><span class="pull-right"><h3>IČO: {{String(contractingAuthority.cin).padStart(8, '0')}}</h3></span>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget title="<h3>Zákazka</h3>" customHeader>
          <b-row>
            <b-col>
              <b-row class="mt-2 mb-2">
                <b-col md="2" class="font-weight-bold">Názov zákazky: </b-col>
                <b-col md="5" :class="{'field-invalid': !order.title.valid}">
                  <b-form-input id="order-title" v-model="order.title.value" type="text" />
                </b-col>
              </b-row>
              <b-row class="mt-2 mb-2">
                <b-col md="2" class="font-weight-bold">Predpokladaná hodnota zákazky:</b-col>
                <b-col md="2" :class="{'field-invalid': !order.estimatedValueAmount.valid}">
                  <vue-numeric class="form-control" currency="€" separator="space" decimal-separator="," :precision="2" :empty-value="0" v-model="order.estimatedValueAmount.value"></vue-numeric>
                </b-col>
                <b-col md="1" :class="{'field-invalid': !order.estimatedValueCurrency.valid}">
                  <b-form-input id="order-estimatedValueCurrency" v-model="order.estimatedValueCurrency.value" type="text" />
                </b-col>
                <b-col md="1" :class="{'field-invalid': !order.estimatedValueVatIncluded.valid}">
                  <b-form-radio-group id="order-vat-included" v-model="order.estimatedValueVatIncluded.value" required>
                    <b-form-radio name="order-vat-radios" :value="true">S DPH</b-form-radio>
                    <b-form-radio name="order-vat-radios" :value="false">Bez DPH</b-form-radio>
                  </b-form-radio-group>
                </b-col>
                <b-col md="1" :class="{'field-invalid': !order.estimatedValueVatRate.valid}">
                  <b-form-input v-if="order.estimatedValueVatIncluded.value === true" id="order-estimatedValueVatRate" v-model="order.estimatedValueVatRate.value" type="text" />
                </b-col>
              </b-row>
               <b-row class="mt-2 mb-2">
                <b-col md="2" class="font-weight-bold">Hlavný CPV kód:</b-col>
                <b-col md="5" :class="{'field-invalid': !order.mainCpv.valid}">
                  <main-cpv-code-select v-model="order.mainCpv.value" ref="cpvCodeSelect"></main-cpv-code-select>
                </b-col>
              </b-row>
              <b-row class="mt-2 mb-2">
                <b-col md="2" class="font-weight-bold">Financovanie z EÚ:</b-col>
                <b-col md="2" :class="{'field-invalid': !order.euFunds.valid}">
                  <b-form-radio-group id="order-euFunds" v-model="order.euFunds.value" required>
                    <b-form-radio name="order-euFunds-radios" :value="true">Áno</b-form-radio>
                    <b-form-radio name="order-euFunds-radios" :value="false">Nie</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mt-2 mb-2">
                <b-col md="2" class="font-weight-bold">Typ zákazky:</b-col>
                <b-col md="2">
                  <contract-type-select v-model="order.contractType.value" :valid="order.contractType.valid"></contract-type-select>
                </b-col>
              </b-row>
              <b-row class="mt-2 mb-2">
                <b-col md="2" class="font-weight-bold">Dátum podpisu zmluvy/objednávky:</b-col>
                <b-col md="2">
                  <date-picker v-model="order.concludedOn.value" :lang="lang" :first-day-of-week="1" type="date" format="DD.MM.YYYY" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </Widget>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget title="<h3>Ponuky </h3>" bodyClass customHeader collapse>
          <div>
            <table class="table table-lg mb-0 offers-table">
              <thead>
                <tr class="text-muted">
                  <th>Dodávateľ</th>
                  <th>Cena</th>
                  <th>Mena</th>
                  <th><i style="cursor: pointer;" class="fa fa-sliders" @click.prevent="unitPriceToggle"></i> Jedn.&nbsp;cena</th>
                  <th><i style="cursor: pointer;" class="fa fa-sliders" @click.prevent="vatToggle"></i> DPH</th>
                  <th>%</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(offer, index) in offers">
                  <tr :key="`offer-${offer.keyTime.toISOString()}-offer`">
                    <td :class="{'field-invalid': !offer.mainContractor.valid}">
                      <contractor-select v-model="offer.mainContractor.value" />
                    </td>
                    <td :class="{'field-invalid': !offer.amount.valid}">
                      <b-form-input :id="`offer-amount-${index}`" style="width: 125px;" v-model="offer.amount.value" type="text" />
                      <b v-if="offer.amount.parsedValue !== null">{{ offer.amount.parsedValue | formatPrice}} {{offer.currency.value}}</b>
                    </td>
                    <td :class="{'field-invalid': !offer.currency.valid}">
                      <b-form-input :id="`offer-currency-${index}`" style="width: 75px;" v-model="offer.currency.value" type="text" />
                    </td>
                    <td :class="{'field-invalid': !offer.isUnitPrice.valid}">
                      <b-form-radio-group :id="`offer-isUnitPrice-${index}`" v-model="offer.isUnitPrice.value" required>
                        <b-form-radio name="isUnitPrice-radios" :value="true">Áno</b-form-radio>
                        <b-form-radio name="isUnitPrice-radios" :value="false">Nie</b-form-radio>
                      </b-form-radio-group>
                    </td>
                    <td :class="{'field-invalid': !offer.vatIncluded.valid}">
                      <b-form-radio-group :id="`offer-vat-included-${index}`" v-model="offer.vatIncluded.value" required>
                        <b-form-radio name="vat-radios" :value="true">S DPH</b-form-radio>
                        <b-form-radio name="vat-radios" :value="false">Bez DPH</b-form-radio>
                      </b-form-radio-group>
                    </td>
                    <td :class="{'field-invalid': !offer.vatRate.valid}">
                      <b-form-input v-if="offer.vatIncluded.value" :id="`offer-vat-${index}`" style="width: 75px;" v-model="offer.vatRate.value" type="number" min="0" max="100" step="1" />
                    </td>
                    <td style="width: 180px;">
                      <b-button variant="success" size="xs" @click.prevent="addGroupContractor(index)">Pridať člena skupiny</b-button>&nbsp;<b-button variant="danger" size="xs" @click.prevent="removeOffer(index)">X</b-button>
                    </td>
                  </tr>
                  <template v-if="offer.isGroup">
                    <tr v-for="(contractor, contractorIndex) in offer.contractors" :key="`${index}-${contractorIndex}`" class="group-contractor">
                      <td><offer-contractor :contractor="contractor" /></td>
                      <td><b-button variant="danger" size="xs" @click.prevent="removeGroupContractor(index, contractorIndex)">X</b-button></td>
                      <td colspan="5"></td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
          <div class="text-right">
            <b-button variant="success" @click.prevent="addNewOffer()">Pridať ponuku</b-button>
          </div>
        </Widget>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget customHeader>
          <b-row class="justify-content-md-center">
            <b-col md="1"></b-col>
            <b-col md="2" class="big-icon">
              <a href="" @click.prevent="goBack()"><i class="fa fa-reply big-icon"></i>
                <br>
                Späť
              </a>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="2" class="big-icon">
              <a href="" @click.prevent="saveOrder()" style="color: #3abf94;"><i class="fa fa-share big-icon"></i>
                <br>
                Odoslať zákazku
              </a>
            </b-col>
            <b-col md="1"></b-col>
          </b-row>
        </Widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import DatePicker from 'vue2-datepicker'
import ContractTypeSelect from '@/components/Custom/ContractTypeSelect'
import MainCpvCodeSelect from '@/components/Custom/MainCpvCodeSelect'
import Widget from "@/components/Widget/Widget";
import AddContractorWIndow from './AddContractorWIndow'
import ContractorSelect from './ContractorSelect'
import OfferContractor from './OfferContractor'
import VueNumeric from 'vue-numeric'
import moment from 'moment'

let formatNumber = require('format-number');
let formatPrice = formatNumber({ integerSeparator: ' ', decimalsSeparator: ' ', decimal: ',' })

export default {
  name: "AddOrderFormular",
  components: { Widget, OfferContractor, ContractorSelect, MainCpvCodeSelect, DatePicker, ContractTypeSelect, VueNumeric },
  data() {
    return {
      lang: {
        days: ['Ned', 'Pon', 'Uto', 'Str', 'Štv', 'Pia', 'Sob'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        pickers: ['7 dní od teraz', '30 dní od teraz', '7 dní do teraz', '30 dní do teraz'],
        placeholder: {
          date: 'Dátum',
          dateRange: 'Vyberte obdobie'
        }
      },
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      order: {},
      offers: [],
      contractingAuthority: {}
    };
  },
  watch: {
    offers: {
      handler (offers) {
        this.validateOffers(offers)
      },
      deep: true
    },
    order: {
      handler () {
        this.validateOrder()
      },
      deep: true
    }
  },
  methods: {
    normalizePrice (price) {
      price = price.replace(/\s/g, "")
      let segments = [...price.matchAll(/[0-9]+/g)]
      if (!segments.length) {
        return null;
      }
      let isDecimal = (segments.length > 1 && segments[segments.length-1][0].length < 3) || (price[segments[segments.length-1].index - 1] === ',')
      if (isDecimal) {
        let decimal = segments.pop()
        return Number(segments.join('') + '.' + decimal)
      } else {
        return Number(segments.join(''))
      }
    },
    addNewOffer () {
      this.offers.push(
        {
          mainContractor: {
            value: null,
            valid: false
          },
          contractors: [],
          isGroup: false,
          amount: {
            value: '',
            valid: false
          },
          isUnitPrice: {
            value: false,
            valid: true
          },
          vatIncluded: {
            value: null,
            valid: false
          },
          vatRate: {
              value: '20',
              valid: false
          },
          currency: {
              value: 'EUR',
              valid: true
          },
          keyTime: new Date()
        }
      )
    },
    removeOffer (offerIndex) {
      this.offers.splice(offerIndex, 1);
    },
    selectMainContractor (offerIndex) {
      let vm = this
      this.$vuedals.open({
        name: 'add-supplier-window',
        title: 'Vyber dodávateľa',
        props: {
          offerIndex: offerIndex,
          isMainContractor: true,
          isGroup: this.offers[offerIndex].isGroup
        },
        component: AddContractorWIndow,
        onClose (data) {
          vm.offers[data.offerIndex].mainContractor.value = data.contractor;
          vm.offers[data.offerIndex].mainContractor.valid = true
        }
      });
    },
    addGroupContractor (offerIndex) {
      let vm = this
      this.$vuedals.open({
          name: 'add-supplier-window',
          title: 'Vyber dodávateľa',
          props: {
            offerIndex: offerIndex,
            isMainContractor: false,
            isGroup: true
          },
          component: AddContractorWIndow,
          onClose (data) {
            vm.offers[data.offerIndex].contractors.push(data.contractor);
            vm.offers[data.offerIndex].isGroup = true
          }
      });
    },
    removeGroupContractor (offerIndex, contractorIndex) {
      this.offers[offerIndex].contractors.splice(contractorIndex, 1);
      this.offers[offerIndex].isGroup = !!this.offers[offerIndex].contractors.length
    },
    validateOrder () {
      let valid = true

      this.order.title.valid = !!this.order.title.value
      valid = valid && this.order.title.valid

      this.order.estimatedValueAmount.valid = this.order.estimatedValueAmount.value
      valid = valid && this.order.estimatedValueAmount.valid

      this.order.estimatedValueCurrency.valid = !!this.order.estimatedValueCurrency.value.length || !this.order.estimatedValueAmount.length
      valid = valid && this.order.estimatedValueCurrency.valid

      this.order.estimatedValueVatIncluded.valid = this.order.estimatedValueVatIncluded.value !== null
      valid = valid && this.order.estimatedValueVatIncluded.valid

      if (this.order.estimatedValueVatIncluded.value) {
        if (!this.order.estimatedValueVatRate.value.length) {
          this.order.estimatedValueVatRate.valid = false
          valid = valid && this.order.estimatedValueVatRate.valid
        } else {
          this.order.estimatedValueVatRate.valid = true          
        }
      } else {
        this.order.estimatedValueVatRate.value = '20'
        this.order.estimatedValueVatRate.valid = true
      }

      this.order.mainCpv.valid = !!this.order.mainCpv.value
      valid = valid && this.order.mainCpv.valid

      this.order.concludedOn.valid = !!this.order.concludedOn.value
      valid = valid && this.order.concludedOn.valid
      
      this.order.euFunds.valid = this.order.euFunds.value !== null
      valid = valid && this.order.euFunds.valid
      
      this.order.contractType.valid = this.order.contractType.value !== null
      valid = valid && this.order.contractType.valid
      
      return valid;
    },
    validateOffers (offers) {
      return offers.map(this.validateOffer).reduce((value, accumulator) => value && accumulator , true)
    },
    validateOffer (offer) {
      let valid = true

      offer.mainContractor.valid = !!offer.mainContractor.value
      valid = valid && offer.mainContractor.valid

      offer.amount.parsedValue = this.normalizePrice(offer.amount.value)
      offer.amount.valid = !!offer.amount.value.length
      valid = valid && offer.amount.valid

      offer.currency.valid = !!offer.currency.value.length || !offer.amount.value.length
      valid = valid && offer.currency.valid

      offer.vatIncluded.valid = !(offer.vatIncluded.value == null) || !offer.amount.value.length
      valid = valid && offer.vatIncluded.valid

      if (offer.vatIncluded.value) {
        if (!offer.vatRate.value.length) {
          offer.vatRate.valid = false
          valid = valid && offer.vatRate.valid
        } else {
          offer.vatRate.valid = true          
        }
      } else {
        offer.vatRate.value = '20'
        offer.vatRate.valid = true
      }

      offer.isUnitPrice.valid = offer.isUnitPrice.value == null ? false : true;
      valid = valid && offer.isUnitPrice.valid

      return valid;
    },
    getOfferData (offer) {
      let response = {
        isGroup: offer.isGroup,
        contractors: [],
        amount: offer.amount.value.length ? Number(offer.amount.value.replace(/\s+/g, '').replace(',', '.')) : null,
        currency: offer.amount.value.length ? offer.currency.value : null,
        vatIncluded: offer.amount.value.length ? offer.vatIncluded.value : null,
        vatRate: offer.vatIncluded.value ? offer.vatRate.value : null,
        isUnitPrice: offer.isUnitPrice.value 
      }

      if (offer.isGroup) {
        response.contractors = offer.contractors.map((contractor) => {
          return {
            cin: contractor.foreignCin || contractor.organization.cin,
            businessName: contractor.name,
            country: contractor.country
          }
        })
      }

      response.contractors.push({
        cin: offer.mainContractor.value.foreignCin || offer.mainContractor.value.organization.cin,
        businessName: offer.mainContractor.value.organization.name,
        country: offer.mainContractor.value.country
      })

      return response
    },
    async saveOrder () {
      
      if (!this.validateOrder()) {
        return
      }
      if (this.offers.length) {
        this.validateOffers(this.offers)
      } else {
        Swal.fire({
          type: 'error',
          text: 'Nie je možné odoslať zákazku bez ponúk!',            
        })
        return        
      }

      let { value: result } = await Swal.fire({
        type: 'question',
        text: 'Ste si istý, že chcete odoslať zákazku ?',
        showCancelButton: true,
        cancelButtonText: 'Zrušiť'
      })
      if (result) {

        let request = {
          contractingAuthorityId: this.contractingAuthority.id,
          title: this.order.title.value,
          contractTypeId: this.order.contractType.value,
          estimatedValueAmount: this.order.estimatedValueAmount.value,
          estimatedValueCurrency: this.order.estimatedValueCurrency.value,
          estimatedValueVatIncluded: this.order.estimatedValueVatIncluded.value,
          estimatedValueVatRate: this.order.estimatedValueVatRate.value,
          mainCpv: this.order.mainCpv.value,
          concludedOn: moment(this.order.concludedOn.value).add(12, 'hours').toISOString(),
          euFunds: this.order.euFunds.value,
          offers: this.offers.map(this.getOfferData)
        }

        let response = await this.$transparexHttp.post('/lv/contracts/', request)
        
        if (response.status !== 201) {
          Swal.fire({
            type: 'error',
            text: 'Nepodarilo sa odoslať zákazku',            
          })
          return;
        }
        let { value: result2 } = await Swal.fire({
          type: 'question',
          text: 'Pridať ďalšiu zákazku ?',
          showCancelButton: true,
          cancelButtonText: 'Zrušiť'
        })

        if (result2) {
          this.offers = []
          this.resetOrder()
        } else {
          this.$router.push({ name: 'ProfilePage', params: { cin: this.$route.params.cin }})
        }
      }
    },
    resetOrder() {
      this.order = {
        title: {
          value: '',
          valid: false
        },
        estimatedValueAmount: {
          value: '',
          valid: false
        },
        estimatedValueCurrency: {
          value: 'EUR',
          valid: true
        },       
        estimatedValueVatIncluded: {
          value: null,
          valid: false
        },
        estimatedValueVatRate: {
          value: 20,
          valid: false
        },
        mainCpv: {
          value: '',
          valid: false
        },
        concludedOn: {
          value: null,
          valid: false
        },        
        euFunds: {
          value: null,
          valid: false
        },
        contractType: {
          value: null,
          valid: false
        }
      }      
      if (this.$refs.cpvCodeSelect) {
        this.$refs.cpvCodeSelect.clear()
      }
      this.addNewOffer()      
    },
      goBack() {
      this.$router.push({ name: 'ProfilePage', params: { cin: this.$route.params.cin }})
    },
    vatToggle() {
      this.offers.forEach(offer => {
        if (offer.vatIncluded.value !== null) {
          offer.vatIncluded.value = !offer.vatIncluded.value
        } else {
          offer.vatIncluded.value = true
        }
      })
    },
    unitPriceToggle() {
      this.offers.forEach(offer => {
        if (offer.isUnitPrice.value !== null) {
          offer.isUnitPrice.value = !offer.isUnitPrice.value
        } else {
          offer.isUnitPrice.value = false
        }
      })
    }
  },
  async created () {
    this.resetOrder()
    let response = await this.$transparexHttp.get('/profiles/cin/' + this.$route.params.cin)
    if (response.status === 200) {
      this.contractingAuthority = response.data
    }
  },
  filters: {
    formatPrice: formatPrice
  }
}

</script>
<style src="./Formular.scss" lang="scss" scoped />